import $ from 'jquery';

import { createSVGElement } from './utils.js';

var $svg = $('#core-values');
var $line_layer = $('#core-values .line-layer');
const WIDTH = 380;
const HEIGHT = 280;
const RADIUS = 70;

//#1C79F9
function calculateCoordinates(theta) {
	var x = WIDTH / 2 + Math.cos(theta) * RADIUS;
	var y = HEIGHT / 2 + Math.sin(theta) * RADIUS;

	return { x, y };
}

function generateSVG() {
	$('#core-values .point').each(function(i) {
		var p = calculateCoordinates(Math.PI / 6 * (2 * i - 1));
		$(this).attr('transform', 'translate(' + p.x + ' ' + p.y + ')');
		
		for (var j = i + 1; j < 6; ++j) {
			// add lines to other points
			var $line = createSVGElement('path');
			var p2 = calculateCoordinates(Math.PI / 6 * (2 * j - 1));

			$line.attr('d', 'M' + p.x + ',' + p.y + ' L' + p2.x + ',' + p2.y);
			$line_layer.append($line);
		}
	});
}

var points = [];
var animationIndex = 0;
var start;

const MAX_CIRCLES = 5;
function animate(timestamp) {

	if (start === undefined) start = timestamp;
	var delta = timestamp - start;

	var t = delta / 1000;

	if (Math.floor(t) !== animationIndex) {
		var $circle = createSVGElement('circle');
		$line_layer.append($circle);

		// pick random start and stop points, make sure that the points
		// are different (r1 != r2)
		var r1 = Math.floor(Math.random() * 6);
		var r2 = Math.floor(Math.random() * 5);
		if (r2 >= r1) ++r2;

		points.unshift({ from: r1, to: r2, t: t, $el: $circle });

		// remove last element of array to truncate
		if (points.length > MAX_CIRCLES) {
			points[points.length - 1].$el.remove();
			points.pop();
		}
	}

	points.forEach(function(point) {
		var p1 = calculateCoordinates(Math.PI / 6 * (2 * point.from - 1));
		var p2 = calculateCoordinates(Math.PI / 6 * (2 * point.to - 1));

		var progress = Math.min(1, (t - point.t) / MAX_CIRCLES);


		point.$el.attr('cx', p1.x + (p2.x - p1.x) * progress); 
		point.$el.attr('cy', p1.y + (p2.y - p1.y) * progress); 
	});
	

	animationIndex = Math.floor(t);	
	window.requestAnimationFrame(animate);
}
// start the animation
window.requestAnimationFrame(animate);

generateSVG();
